module.exports = __webpack_public_path__ + "static/media/clima_img.949320f8.png";